export default __webpack_public_path__ + "static/media/dahua.e4613481.png";